import { Component } from '@angular/core';

@Component({
  selector: 't-united-adherence-program-message',
  imports: [],
  templateUrl: './united-adherence-program-message.html',
  styles: [
    `
      .custom-bg-united {
        background: radial-gradient(183.25% 90.83% at 12.5% 98.21%, #012675 0%, #002677 100%);
      }
    `,
  ],
})
export class UnitedAdherenceProgramMessage {}
